import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import UFOSegment from '@atlaskit/react-ufo/ufo-segment';

export const UFOv2: {
	SegmentNames: { REMOTE_PLACEMENT: string; PLACEMENT: string; MESSAGE: string };
	HoldNames: { REMOTE_PLACEMENT: string; PLACEMENT: string; MESSAGE: string };
	UFOLoadHold: typeof UFOLoadHold;
	UFOSegment: typeof UFOSegment;
} = {
	/** Names for UFOv2 segments for Post Office */
	SegmentNames: {
		REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
		PLACEMENT: 'post-office-placement',
		MESSAGE: 'post-office-message',
	},
	/** Names for UFOv2 holds for Post Office */
	HoldNames: {
		REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
		PLACEMENT: 'post-office-placement-loading',
		MESSAGE: 'post-office-message-loading',
	},
	UFOLoadHold: UFOLoadHold as any,
	UFOSegment: UFOSegment as any,
};
